import BaseServiceCrud from './BaseServiceCrud';

export default class CardService extends BaseServiceCrud {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'user-cards';
    }

    getCriteria(criteria) {
        return this.objToQueryString({
            date_from: criteria.dateFrom,
            date_to: criteria.dateTo,
            query: criteria.query,
            account_role: criteria.accountRole?.enumValue,
            status: criteria.status?.enumValue,
            first_result: criteria.firstResult,
            max_result: criteria.maxResults,
            sort_field: criteria.sortField,
            sort_asc: criteria.sortAsc,
        });
    }
    getCardCountInfo() {
        return this.fetch(`${this.domain}/${this.path}/card-count-info`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    unauthorizeMobileUser(request) {
        return this.fetch(`${this.domain}/${this.path}/back-off`, {
            method: 'PUT',
            body: JSON.stringify(request),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
	authorizeMobileUser(request){
		return this.fetch(`${this.domain}/${this.path}/au-mobile-user`, {
            method: 'PUT',
            body: JSON.stringify(request),
        }).then((res) => {
            return Promise.resolve(res);
        });
	}
    getUserInfo(id) {
        return this.fetch(`${this.domain}/${this.path}/user-info/${id}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    updatePin(request) {
        return this.fetch(`${this.domain}/${this.path}/update-pin`, {
            method: 'PUT',
            body: JSON.stringify(request),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    updateRole(request) {
        return this.fetch(`${this.domain}/${this.path}/update-role`, {
            method: 'PUT',
            body: JSON.stringify(request),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
}
